import { TaxService } from '../../helpers/services/Tax.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const TAX_MODULE = 'tax'; 

// define action 
export const GET_ALL_TAXES = 'getAllTaxes';
export const GET_TAX = 'getTax';
export const UPDATE_TAX = 'updateTax';
export const CREATE_TAX = 'createTax';
export const UPDATE_TAX_STATUS = 'updateTaxStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_TAXES_REQUEST = "getAllTaxes";
const GET_TAX_REQUEST = "getTax";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_TAXES]({ commit }, { filter }) {
        TaxService
            .getAllTaxes(filter)
            .then(
                (result) => {
                    commit(GET_ALL_TAXES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_TAX]({ commit }, { id }) {
        TaxService
            .getTax(id)
            .then(
                (result) => {
                    commit(GET_TAX_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TAX]({ commit }, { data }) {
        commit(REQUEST)
        TaxService
            .updateTax(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.Tax')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_TAX]({ commit }, { data }) {
        commit(REQUEST)
        TaxService
            .createTax(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.Tax')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TAX_STATUS]({ dispatch }, { filter, data }) {
        TaxService
            .updateTaxStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_TAXES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Tax-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_TAXES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                percentage: o.percentage,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_TAX_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            percentage: o.percentage,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


